import { Table as ActionTypes } from '../actionTypes';

const set = payload => ({
  type: ActionTypes.SET,
  payload: payload.map(item => ({
    Table: item,
    Columns: [],
  })),
});

const setColumn = payload => ({
  type: ActionTypes.SET_COLUMN,
  payload,
});

export default {
  set,
  setColumn,
};
